export default {
    //轮播列表
    getSliders (params) {
        return new Promise((resolve, reject) => {
            axios.get('/api/home/sliders', {
                params:params
            })
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    getAdvs (params) {
        return new Promise((resolve, reject) => {
            axios.get('/api/advs', {
                params:params
            })
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    //资讯列表
    getHomeList (params) {
        return new Promise((resolve, reject) => {
            axios.get('/api/home/index-new-lists',{
                params:params
            })
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    //直播列表
    getLiveList(params) {
        return new Promise((resolve, reject) => {
            axios.get('/api/live/list',{
                params:params
            })
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    getHeadlinesList(params) {
        return new Promise((resolve, reject) => {
            axios.get('/api/home/index-headlines',{
                params:params
            })
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    //资讯列表
    getList (params) {
        return new Promise((resolve, reject) => {
            axios.get('/api/home/lists',{
                params:params
            })
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    //资讯列表
    getIndexList (params) {
        return new Promise((resolve, reject) => {
            axios.get('/api/home/index-lists',{
                params:params
            })
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    //详情
    getShow (id, params) {
        return new Promise((resolve, reject) => {
            axios.get('/api/archive/' + id, {
                params:params
            })
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    //文章点赞
    setPraise(params){
        return new Promise((resolve, reject) => {
            axios.post('/api/archive/praise',params)
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    //文章无帮助
    setNoPraise(params){
        return new Promise((resolve, reject) => {
            axios.post('/api/archive/praise-no',params)
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    //评论点赞
    setCommentPraise(params){
        return new Promise((resolve, reject) => {
            axios.post('/api/archive/comment/praise',params)
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    //资讯推荐
    getRecommends (id, params) {
        return new Promise((resolve, reject) => {
            axios.get('/api/archive/' + id + '/recommends', {
                params:params
            })
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    //评论/回复
    Comment (params) {
        return new Promise((resolve, reject) => {
            axios.post('/api/archive/comment',params)
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    //评论详情
    getCommentShow (id, params) {
        return new Promise((resolve, reject) => {
            axios.get('/api/archive-comment/' + id,{
                params:params
            })
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    //评论回复详情
    getCommentReplys (id, params) {
        return new Promise((resolve, reject) => {
            axios.get('/api/archive-comment/' + id + '/replys',{
                params:params
            })
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    //评论点赞
    setCommentPraise(params){
        return new Promise((resolve, reject) => {
            axios.post('/api/archive/comment/praise',params)
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    //收藏
    Collect(params){
        return new Promise((resolve, reject) => {
            axios.post('/api/archive/collect',params)
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    //评论删除
    delComment(id){
        return new Promise((resolve, reject) => {
            axios.delete('/api/archive-comment/'+id+'/delete')
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    //标签
    getChannelInfo(){
        return new Promise((resolve, reject) => {
            axios.get('/api/archive/channel')
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        }) 
    },
    //评论列表
    getCommentList (id, params) {
        return new Promise((resolve, reject) => {
            axios.get('/api/archive/' + id + '/comments',{
                params:params
            })
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    //关注
    Follow (params) {
        return new Promise((resolve, reject) => {
            axios.post('/api/user/follow',params)
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    //话题列表
    getTopicList(params){
       return new Promise((resolve, reject) => {
        axios.get('/api/topic/lists',{
            params:params
        })
        .then((response) => {
            resolve(response)
        })
    }, err => {
        reject(err)
    })
   },
   //话题详情
   getTopicShow (id) {
    return new Promise((resolve, reject) => {
        axios.get('/api/topic/' + id)
        .then((response) => {
            resolve(response)
        })
    }, err => {
        reject(err)
    })
},
//活动列表
getActiveList(params){
    return new Promise((resolve, reject) => {
        axios.get('/api/huodong/lists',{
            params:params
        })
        .then((response) => {
            resolve(response)
        })
    }, err => {
        reject(err)
    })
},
getChannel(params){
    return new Promise((resolve, reject) => {
        axios.get('/api/archive/media/channel',{params:params})
        .then((response) => {
            resolve(response)
        })
    }, err => {
        reject(err)
    }) 
},
//商品类目
getCategories (params) {
    return new Promise((resolve, reject) => {
        axios.get('/api/shop/categories')
        .then((response) => {
            resolve(response)
        })
    }, err => {
        reject(err)
    })
},
//商品列表
getShopList (params) {
    return new Promise((resolve, reject) => {
        axios.get('/api/shop/goods',{
            params:params
        })
        .then((response) => {
            resolve(response)
        })
    }, err => {
        reject(err)
    })
},
//直播详情
getLiveShow (id) {
    return new Promise((resolve, reject) => {
        axios.get('/api/live/' + id)
        .then((response) => {
            resolve(response)
        })
    }, err => {
        reject(err)
    })
},
//直播状态
getLiveStatus (id) {
    return new Promise((resolve, reject) => {
        axios.get('/api/live/status/' + id)
        .then((response) => {
            resolve(response)
        })
    }, err => {
        reject(err)
    })
},
//直播评论列表
getLiveComments (params,id) {
    return new Promise((resolve, reject) => {
        axios.get('/api/live/' + id+ '/comments',{
                params:params
            })
        .then((response) => {
            resolve(response)
        })
    }, err => {
        reject(err)
    })
},
//直播发评论
LiveComment(params) {
        return new Promise((resolve, reject) => {
            axios.post('/api/live/comment',params)
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    //获取海报
    getPoster(params){
        return new Promise((resolve, reject) => {
            axios.get('/api/archive/share-poster',{
                params:params
            })
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    //
    getScrollList(media_id){
        return new Promise((resolve, reject) => {
            axios.get('/api/notice/index',{
                params:{
                    media_id:media_id
                }
            })
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    getShare(params){
        return new Promise((resolve, reject) => {
            axios.post('/api/wechat/share-info',params)
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    getGroupList(params){
        return new Promise((resolve, reject) => {
            axios.get('/api/group/list',{params:params})
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    getNewVersion(params){
        return new Promise((resolve, reject) => {
            axios.get('/api/setting/version',{params:params})
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    getAgreement(params){
        return new Promise((resolve, reject) => {
            axios.get('/api/setting/agreement',{params:params})
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
}